import * as regionsKeyset from 'i18n/Region';

export const YANDEX_COUNTRIES_LIST: (keyof (typeof regionsKeyset)['en'])[] = ['RU', 'KZ', 'BY', 'UZ', 'AZ'];
export const YANDEX_COUNTRIES_SET = new Set(YANDEX_COUNTRIES_LIST);

export const YANGO_COUNTRIES_LIST: (keyof (typeof regionsKeyset)['en'])[] = [
    'DZ',
    'BH',
    'EG',
    'JO',
    'QA',
    'KW',
    'AE',
    'OM',
    'SA',
];
